import React from 'react';
import takeYourHeart from '../images/take your heart.png';
import deviceDemo from '../images/devicedemo.png';

export const AppPreview = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background Image */}
      <img
        src={takeYourHeart}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover object-center z-0"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/55 z-[1]"></div>
      {/* Subtle color blobs */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-red-600 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse z-[2]"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse z-[2]" style={{ animationDelay: '1s' }}></div>

      {/* PHANTOM THIEF — floating above the bg image */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[20vw] font-anton text-white opacity-10 whitespace-nowrap select-none rotate-12 z-[3] pointer-events-none">
        PHANTOM THIEF
      </div>

      <div className="container mx-auto px-4 relative z-[10]">
        <div className="flex flex-col items-center mb-16">
          <h2 className="bg-white text-black font-anton text-5xl md:text-6xl px-8 py-2 transform -skew-x-12 rotate-2 border-4 border-black box-shadow-hard mb-4">
            TAKE YOUR HEART
          </h2>
          <p className="text-white font-marker text-xl transform -rotate-1">The interface that changes the game.</p>
        </div>

        {/* Dashboard Mockup Grid */}
        <div className="grid md:grid-cols-12 gap-6 items-center">
          {/* Left Control Panel */}
          <div className="md:col-span-4 space-y-4">
            <div className="bg-black border-2 border-yellow-400 p-4 transform -skew-x-6 hover:translate-x-2 transition-transform cursor-pointer group">
              <div className="flex justify-between items-center text-white">
                <span className="font-anton text-2xl tracking-wide group-hover:text-yellow-400">LIVE TABLES</span>
                <iconify-icon icon="solar:play-bold" width="24" className="text-yellow-400"></iconify-icon>
              </div>
            </div>
            <div className="bg-white border-2 border-black p-4 transform skew-x-3 hover:translate-x-2 transition-transform cursor-pointer group ml-8">
              <div className="flex justify-between items-center text-black">
                <span className="font-anton text-2xl tracking-wide group-hover:text-yellow-400">GLOBAL RANK</span>
                <iconify-icon icon="solar:cup-star-bold" width="24"></iconify-icon>
              </div>
            </div>
            <div className="bg-black border-2 border-gray-500 p-4 transform -skew-x-3 hover:translate-x-2 transition-transform cursor-pointer group ml-4">
              <div className="flex justify-between items-center text-gray-300">
                <span className="font-anton text-2xl tracking-wide group-hover:text-white">PRIVATE MATCH</span>
                <iconify-icon icon="solar:key-linear" width="24"></iconify-icon>
              </div>
            </div>
          </div>

          {/* Center Phone/Device Mockup */}
          <div className="md:col-span-4 flex justify-center">
            <div className="relative w-64 h-[500px] bg-black border-4 border-white rounded-3xl transform rotate-3 shadow-[0_0_50px_rgba(217,35,35,0.4)] overflow-hidden">
              {/* Device screenshot fills the screen */}
              <img
                src={deviceDemo}
                alt="App Demo"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Stats */}
          <div className="md:col-span-4 relative">
            <div className="bg-white text-black p-6 clip-jagged border-4 border-red-600 transform rotate-2">
              <h4 className="font-anton text-2xl mb-2">ACTIVE NOW</h4>
              <div className="flex items-end gap-2 font-sans font-bold text-4xl">
                2,430<span className="text-sm font-normal text-gray-500 mb-1 ml-2">players</span>
              </div>
              <div className="mt-4 flex gap-2">
                <span className="px-2 py-1 bg-black text-white text-xs font-bold uppercase">Global Peak</span>
                <span className="px-2 py-1 bg-yellow-400 text-black text-xs font-bold uppercase">Ready to Play</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
